import {
    ChangeInfoParams,
    CreateIdentity,
    IdentityConsent,
    UpdateConsent,
} from '../../types/identity'
import bikekeyApi, { IDENTITY_CONSENTS, IDENTITY_LANGUAGE, TagAbstractIds } from './bikekeyApi'

const identitiesApi = bikekeyApi.injectEndpoints({
    endpoints: (builder) => ({
        createIdentity: builder.mutation<{ authentication_token: string }, CreateIdentity>({
            query: (body: CreateIdentity) => ({
                url: `/identities/`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [],
        }),
        deleteIdentity: builder.mutation({
            query: ({ partyIdToDelete }: { partyIdToDelete: string }) => ({
                url: `/identities/${partyIdToDelete}/`,
                method: 'DELETE',
            }),
            invalidatesTags: [],
        }),
        updateIdentity: builder.mutation({
            query: (body: ChangeInfoParams) => ({
                url: `/identities/me`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [],
        }),
        setConsent: builder.mutation({
            query: ({ consentType, action }: UpdateConsent) => ({
                url: `/identities/consents/${consentType}/`,
                method: 'POST',
                body: { action },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: IDENTITY_CONSENTS, id: arg.consentType },
                { type: IDENTITY_CONSENTS, id: TagAbstractIds.LIST },
            ],
        }),
        getConsents: builder.query<{ consents: IdentityConsent[] }, void>({
            query: () => ({
                url: `/identities/consents/`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [
                { type: IDENTITY_CONSENTS, id: TagAbstractIds.LIST },
            ],
        }),
        getLanguage: builder.query<{ language: string }, void>({
            query: () => ({
                url: `/identities/language/`,
                method: 'GET',
            }),
            providesTags: [{ type: IDENTITY_LANGUAGE, id: TagAbstractIds.LIST }],
        }),
        updateLanguage: builder.mutation<void, { language: string }>({
            query: ({ language }: { language: string }) => ({
                url: `/identities/language/`,
                method: 'PUT',
                body: { language },
            }),
            invalidatesTags: [{ type: IDENTITY_LANGUAGE, id: TagAbstractIds.LIST }],
        }),
        getRegion: builder.query<{ region: string }, void>({
            query: () => ({
                url: `/identities/region/`,
                method: 'GET',
            }),
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useDeleteIdentityMutation,
    useUpdateIdentityMutation,
    useGetConsentsQuery,
    useSetConsentMutation,
    useCreateIdentityMutation,
    useGetLanguageQuery,
    useUpdateLanguageMutation,
    useGetRegionQuery,
} = identitiesApi
